import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import * as actions from './redux/actions';
import moment from 'moment';
import 'moment/locale/de'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import PlansEditor from './PlansEditor';
import {getError } from '../common/getError'
import { CircularProgress, LinearProgress } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export class SeasonsEditor extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    
    editedSeasonId: -1,
  }

  planSavingId = Math.random()*1000000;

  handleClick(event, s)
  {
    this.setState({ ["anchorEl"+s.id]: event.currentTarget });
  }

  handleClose(s) {
    this.setState({ ["anchorEl"+s.id]: null });
}

constructor(props)
{
  console.log("construct");
  super(props);
}

componentWillReceiveProps(nextProps) {
  
  console.log(this.state);
  console.log({nextProps});
  if (this.state.startedSavePlans && !nextProps.home.savePlansPending && !nextProps.home.savePlansError) {
    this.setState({ startedSavePlans: false, editedSeasonId: -1 });
  }
}

  render() {
    return (
      <div className="home-seasons-editor">
        <Paper style={{margin:"12px", padding:"12px"}}>
        
        <div>
          <h2>Einteilungszeiträume</h2>
          {this.props.home.syncPlansWithPcoPending && <LinearProgress />}
          {this.props.home.syncPlansWithPcoError && getError(this.props.home.syncPlansWithPcoError) }
          {this.props.home.saveSeasonError && getError(this.props.home.saveSeasonError) }
          <Table>
<TableHead>
  <TableCell>Von</TableCell>
  <TableCell>Bis einschließlich</TableCell>
  <TableCell></TableCell>
  <TableCell></TableCell>
</TableHead>

{Object.values(this.props.home.seasons).map(s => [<TableRow id={"season"+s.id}>
         <TableCell>{moment.utc(s.from).format("DD.MM.YYYY")}</TableCell>
         <TableCell>{moment.utc(s.to).format("DD.MM.YYYY")}</TableCell>
         <TableCell>

{
  s.id === this.state.editedSeasonId ? 
  <span>
    {this.props.home.savePlansError && getError(this.props.home.savePlansError) }
    <Button variant="outlined" onClick={() => {this.setState({editedSeasonId: -1,startedSavePlans: false});this.props.actions.fetchModelData();}}>Abbrechen</Button>
    &nbsp;
    {Object.values(this.props.home.plans).some(p => p.dirty) && 
    <Button disabled={this.props.home.savePlansPending} variant="contained" color="secondary" onClick={() => {this.props.actions.savePlans(Object.values(this.props.home.plans).filter(p => p.dirty));this.setState({startedSavePlans: true}); }}>Speichern</Button>
    }
    </span>
  : 
        <Button
        variant="contained"
        color="primary"
                aria-owns={this.state["anchorEl"+s.id] ? 'simple-menu'+s.id : undefined}
    aria-haspopup="true"
                onClick={(evt) => this.handleClick(evt, s)}
        >
          Aktionen
    </Button>
}
        <Menu id = {"simple-menu"+s.id}
    anchorEl = { this.state["anchorEl"+s.id] }
                open={Boolean(this.state["anchorEl"+s.id]) }
                onClose={this.handleClose.bind(this,s)} >
                  <MenuItem onClick={() =>  {this.props.actions.createSchedule(s.id);this.props.close(); }}>Plan erstellen</MenuItem>
                  <MenuItem onClick={() =>  {this.handleClose(s);confirmAlert({
      title: 'Einteilungszeitraum löschen?',
      message: 'Achtung, damit werden auch alle Pläne für diesen Zeitraum gelöscht. Ergebnisse von Terminumfragen bleiben jedoch erhalten.',
      buttons: [
        {
          label: 'Löschen',
          onClick: () => {this.props.actions.deleteSeason(s)}
        },
        {
          label: 'Abbrechen',
          onClick: () => {}
        }
      ]
    })}}>Einteilungszeitraum löschen</MenuItem>
                  <MenuItem onClick={() => {if (!this.props.home.syncPlansWithPcoPending) this.props.actions.syncPlansWithPco(s.id);this.handleClose(s);}}>Gottesdienste aus PCO laden {this.props.home.syncPlansWithPcoPending && <CircularProgress />} </MenuItem>
                  <MenuItem onClick={() => {this.setState({editedSeasonId: s.id});this.handleClose(s);}}>Gottesdienste bearbeiten</MenuItem>
                  {!s.openForSurvey && <MenuItem onClick={() => {this.props.actions.saveSeason({...s, openForSurvey: true});this.handleClose(s);}}>Für Umfrage öffnen</MenuItem>}
                  {s.openForSurvey && <MenuItem onClick={() => {this.props.actions.saveSeason({...s, openForSurvey: false});this.handleClose(s);}}>Für Umfrage schließen</MenuItem>}
                  
                  </Menu>
                  </TableCell>    
                  <TableCell>{s.openForSurvey && <span>Für Umfrage geöffnet</span>}</TableCell>
</TableRow>].concat(
  s.id === this.state.editedSeasonId ? <TableRow><TableCell colSpan={4}>
    <PlansEditor seasonId={s.id}/>
</TableCell><TableCell /></TableRow>
 : null
)  )}
<TableRow>
  <TableCell><TextField
          onChange={(evt) => {this.setState({newSeason: {...this.state.newSeason, from: evt.target.value}}); console.log(this.state);}}
        name="newFrom"
        
        type="date"/></TableCell>
  <TableCell><TextField
            onChange={(evt) => {this.setState({newSeason: {...this.state.newSeason, to: evt.target.value}}); console.log(this.state);}}
        name="newTo"
        label=""
        type="date"/></TableCell>
  <TableCell><Button disabled={!(this.state.newSeason && this.state.newSeason.from && this.state.newSeason.to)} variant="contained" 
    onClick={() => this.props.actions.createSeason({from: moment.utc(this.state.newSeason.from).toISOString(), to: moment.utc(this.state.newSeason.to).toISOString()}) }>Neuen Zeitraum erstellen</Button></TableCell>
<TableCell />
</TableRow>
                  </Table>

                  <Dialog
        open={Boolean(this.props.home.syncPlansWithPcoMessages)}
        onClose={() => this.props.actions.dismissSyncPlansWithPcoMessages()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Warnungen beim Synchronisieren mit dem Planning Center"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {this.props.home.syncPlansWithPcoMessages && this.props.home.syncPlansWithPcoMessages.split('\n').map(function(item, key) {
  return (
    <span key={key}>
      {item}
      <br/>
    </span>
  )
})}
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.actions.dismissSyncPlansWithPcoMessages()} color="primary">
           Ok
          </Button>
          
        </DialogActions>
      </Dialog>

        </div>
        
        
                
        </Paper>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeasonsEditor);



// WEBPACK FOOTER //
// ./src/features/home/SeasonsEditor.js